<div class="monster-image-dialog"
  [ngClass]="{'closed' : !opened, 'opened' : opened}">
  <img  [src]="gameManager.monsterManager.monsterArtwork(monster)">
</div>
<div class="close-container" (click)="close()"></div>